import { t } from '@lingui/core/macro'

declare global {
    interface Window {
        ApplePaySession?: any
    }
}

export const getReasonMessage = (): string | null => {
    if (!/iPhone|iPad|iPod|MacIntel/.test(navigator.platform)) {
        return t`Оплата через Apple Pay не доступна на этом устройстве`
    }

    if (typeof window.ApplePaySession === 'undefined') {
        return t`Оплата через Apple Pay не поддерживается этим браузером`
    }

    const ApplePaySession = window.ApplePaySession

    if (!ApplePaySession.supportsVersion(3)) {
        return t`Требуется более новая версия Apple Pay API`
    }

    if (!ApplePaySession.canMakePayments()) {
        return t`На устройстве нет настроенных карт для Apple Pay`
    }

    return null
}

export const availableApplePay = getReasonMessage() === null
